export class ListDataCatalogsResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "nextToken",
            "baseName": "nextToken",
            "type": "string",
            "format": ""
        },
        {
            "name": "totalCount",
            "baseName": "totalCount",
            "type": "number",
            "format": ""
        },
        {
            "name": "catalogs",
            "baseName": "catalogs",
            "type": "Array<DataCatalog>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListDataCatalogsResponse.attributeTypeMap;
    }
    constructor() {
    }
}
